import { render } from "./FAQCard.vue?vue&type=template&id=242f263b&scoped=true"
import script from "./FAQCard.vue?vue&type=script&lang=js"
export * from "./FAQCard.vue?vue&type=script&lang=js"

import "./FAQCard.vue?vue&type=style&index=0&id=242f263b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242f263b"]])

export default __exports__